/** Agent signup — non-English overrides (derived from user signup + agent-specific) */
export const panelAgentSignupByLang = {
  es: {
    'agent.signup.title': 'Registro de agente',
    'agent.signup.subtitle': 'Crea tu cuenta de agente. Tras el registro, un administrador debe aprobarla antes de que puedas iniciar sesión.',
    'agent.signup.secondaryText': '¿Ya tienes cuenta?',
    'agent.signup.secondaryLabel': 'Entrar',
    'agent.signup.backToSite': 'Volver al sitio principal',
    'agent.signup.toastCreated': 'Cuenta registrada — pendiente de aprobación. No puedes iniciar sesión hasta que sea aprobada.',
    'agent.signup.toastSaveRecoveryFirst': 'Cuenta registrada — guarda tu frase de recuperación. El acceso permanece bloqueado hasta la aprobación.',
    'agent.signup.pendingNotice': 'Tu cuenta de agente está pendiente de aprobación del administrador. No puedes iniciar sesión hasta que se active. Contacta support@mineme.site si necesitas ayuda.',
    'agent.signup.error.nameRequired': 'El nombre completo es obligatorio.',
    'agent.signup.error.usernameInvalid': 'El usuario solo puede contener letras, números y guiones opcionales.',
    'agent.signup.error.usernameMin': 'El usuario debe tener al menos {{min}} caracteres.',
    'agent.signup.error.usernameMax': 'El usuario debe tener como máximo {{max}} caracteres.',
    'agent.signup.error.usernameTaken': 'Este nombre de usuario ya está en uso.',
    'agent.signup.error.usernameCheckWait': 'Espera a que termine la comprobación del usuario.',
    'agent.signup.error.emailRequired': 'El correo es obligatorio.',
    'agent.signup.error.passwordRequired': 'La contraseña es obligatoria.',
    'agent.signup.error.confirmRequired': 'Confirmar la contraseña es obligatorio.',
    'agent.signup.error.passwordsMismatch': 'Las contraseñas no coinciden.',
    'agent.signup.error.passwordMin': 'La contraseña debe tener al menos 8 caracteres.',
    'agent.signup.error.captchaWrong': 'El captcha es obligatorio y debe ser correcto.',
    'agent.signup.error.referralRequired': 'El código de referido de agente es obligatorio.',
    'agent.signup.error.referralInvalid':
      'El código solo puede contener letras, números y guiones opcionales.',
    'agent.signup.error.registrationFailed': 'Error en el registro',
    'agent.signup.form.labelFullName': 'Nombre completo',
    'agent.signup.form.placeholderFullName': 'Tu nombre legal',
    'agent.signup.form.labelUsername': 'Usuario',
    'agent.signup.form.placeholderUsername': 'Elige tu usuario de agente',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} caracteres sin guiones; letras y números (guiones permitidos al escribir).',
    'agent.signup.form.labelReferral': 'Código de referido de agente (obligatorio)',
    'agent.signup.form.placeholderReferral': 'Usuario del agente patrocinador',
    'agent.signup.form.referralHint':
      'Solo un agente existente puede referir a un nuevo agente. No se pueden usar cuentas de usuario.',
    'agent.signup.form.labelEmail': 'Correo',
    'agent.signup.form.placeholderEmail': 'Introduce el correo',
    'agent.signup.form.labelPassword': 'Contraseña (obligatoria)',
    'agent.signup.form.placeholderPassword': 'Crea una contraseña',
    'agent.signup.form.labelConfirmPassword': 'Confirmar contraseña (obligatoria)',
    'agent.signup.form.placeholderConfirmPassword': 'Confirma la contraseña',
    'agent.signup.form.captchaRobot': 'No soy un robot (obligatorio)',
    'agent.signup.form.captchaQuestion': 'Captcha: ¿cuánto es {{a}} + {{b}}?',
    'agent.signup.form.placeholderCaptcha': 'Respuesta del captcha',
    'agent.signup.form.submitting': 'Creando…',
    'agent.signup.form.submit': 'Crear cuenta',
    'agent.signup.username.available': 'Este usuario está disponible.',
    'agent.signup.username.taken': 'Este usuario ya está en uso.',
    'agent.signup.username.invalidChars': 'Usa solo letras, números y guiones opcionales.',
    'agent.signup.username.invalidMin': 'El usuario debe tener al menos {{min}} caracteres (sin guiones).',
    'agent.signup.username.invalidGeneric': 'Este usuario no se puede usar.',
    'agent.signup.recovery.title': 'Guarda tu frase de recuperación',
    'agent.signup.recovery.body': 'Solo podemos mostrarla ahora. Escríbela y guárdala sin conexión. La necesitarás para restablecer la contraseña si la olvidas.',
    'agent.signup.recovery.warn': 'Nunca compartas esta frase. Quien la tenga puede restablecer tu contraseña.',
    'agent.signup.recovery.copy': 'Copiar frase',
    'agent.signup.recovery.copiedToast': 'Frase copiada',
    'agent.signup.recovery.checkbox': 'He anotado o guardado de forma segura mi frase de recuperación de 12 palabras.',
    'agent.signup.recovery.continue': 'Continuar',
  },
  de: {
    'agent.signup.title': 'Agent-Registrierung',
    'agent.signup.subtitle': 'Erstellen Sie Ihr Agentenkonto. Nach der Registrierung muss ein Admin Ihr Konto freigeben, bevor Sie sich anmelden können.',
    'agent.signup.secondaryText': 'Bereits ein Konto?',
    'agent.signup.secondaryLabel': 'Anmelden',
    'agent.signup.backToSite': 'Zurück zur Hauptseite',
    'agent.signup.toastCreated': 'Konto registriert — wartet auf Freigabe. Anmeldung erst nach Genehmigung möglich.',
    'agent.signup.toastSaveRecoveryFirst': 'Konto registriert — speichern Sie Ihre Wiederherstellungsphrase. Login bleibt bis zur Freigabe gesperrt.',
    'agent.signup.pendingNotice': 'Ihr Agentenkonto wartet auf Admin-Freigabe. Sie können sich erst nach der Aktivierung anmelden. Kontakt: support@mineme.site.',
    'agent.signup.error.nameRequired': 'Vollständiger Name ist erforderlich.',
    'agent.signup.error.usernameInvalid': 'Der Benutzername darf nur Buchstaben, Zahlen und optionale Bindestriche enthalten.',
    'agent.signup.error.usernameMin': 'Der Benutzername muss mindestens {{min}} Zeichen haben.',
    'agent.signup.error.usernameMax': 'Der Benutzername darf höchstens {{max}} Zeichen haben.',
    'agent.signup.error.usernameTaken': 'Dieser Benutzername ist bereits vergeben.',
    'agent.signup.error.usernameCheckWait': 'Bitte warten Sie, bis die Benutzername-Prüfung abgeschlossen ist.',
    'agent.signup.error.emailRequired': 'E-Mail ist erforderlich.',
    'agent.signup.error.passwordRequired': 'Passwort ist Pflicht.',
    'agent.signup.error.confirmRequired': 'Passwortbestätigung ist Pflicht.',
    'agent.signup.error.passwordsMismatch': 'Passwörter stimmen nicht überein.',
    'agent.signup.error.passwordMin': 'Das Passwort muss mindestens 8 Zeichen haben.',
    'agent.signup.error.captchaWrong': 'Captcha ist Pflicht und muss richtig sein.',
    'agent.signup.error.referralRequired': 'Agenten-Empfehlungscode ist erforderlich.',
    'agent.signup.error.referralInvalid':
      'Der Code darf nur Buchstaben, Zahlen und optionale Bindestriche enthalten.',
    'agent.signup.error.registrationFailed': 'Registrierung fehlgeschlagen',
    'agent.signup.form.labelFullName': 'Vollständiger Name',
    'agent.signup.form.placeholderFullName': 'Ihr rechtlicher Name',
    'agent.signup.form.labelUsername': 'Benutzername',
    'agent.signup.form.placeholderUsername': 'Agent-Benutzername wählen',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} Zeichen ohne Bindestriche; Buchstaben und Zahlen (Bindestriche beim Tippen erlaubt).',
    'agent.signup.form.labelReferral': 'Agenten-Empfehlungscode (Pflicht)',
    'agent.signup.form.placeholderReferral': 'Benutzername des Sponsor-Agenten',
    'agent.signup.form.referralHint':
      'Nur ein bestehender Agent kann einen neuen Agenten werben. Nutzerkonten sind nicht zulässig.',
    'agent.signup.form.labelEmail': 'E-Mail',
    'agent.signup.form.placeholderEmail': 'E-Mail eingeben',
    'agent.signup.form.labelPassword': 'Passwort (Pflicht)',
    'agent.signup.form.placeholderPassword': 'Passwort erstellen',
    'agent.signup.form.labelConfirmPassword': 'Passwort bestätigen (Pflicht)',
    'agent.signup.form.placeholderConfirmPassword': 'Passwort bestätigen',
    'agent.signup.form.captchaRobot': 'Ich bin kein Roboter (Pflicht)',
    'agent.signup.form.captchaQuestion': 'Captcha: Wie viel ist {{a}} + {{b}}?',
    'agent.signup.form.placeholderCaptcha': 'Captcha-Antwort eingeben',
    'agent.signup.form.submitting': 'Wird erstellt…',
    'agent.signup.form.submit': 'Konto erstellen',
    'agent.signup.username.available': 'Dieser Benutzername ist verfügbar.',
    'agent.signup.username.taken': 'Dieser Benutzername ist bereits vergeben.',
    'agent.signup.username.invalidChars': 'Nur Buchstaben, Zahlen und optionale Bindestriche.',
    'agent.signup.username.invalidMin': 'Mindestens {{min}} Zeichen (ohne Bindestriche).',
    'agent.signup.username.invalidGeneric': 'Dieser Benutzername kann nicht verwendet werden.',
    'agent.signup.recovery.title': 'Wiederherstellungsphrase sichern',
    'agent.signup.recovery.body': 'Wir können sie nur dieses eine Mal anzeigen. Notieren und offline aufbewahren. Sie brauchen sie, um Ihr Passwort zurückzusetzen, falls Sie es vergessen.',
    'agent.signup.recovery.warn': 'Teilen Sie diese Phrase niemals. Wer sie hat, kann Ihr Passwort zurücksetzen.',
    'agent.signup.recovery.copy': 'Phrase kopieren',
    'agent.signup.recovery.copiedToast': 'Phrase kopiert',
    'agent.signup.recovery.checkbox': 'Ich habe meine 12-Wort-Wiederherstellungsphrase notiert oder sicher gespeichert.',
    'agent.signup.recovery.continue': 'Weiter',
  },
  fr: {
    'agent.signup.title': 'Inscription agent',
    'agent.signup.subtitle': 'Créez votre compte agent. Après l\'inscription, un administrateur doit l\'approuver avant que vous puissiez vous connecter.',
    'agent.signup.secondaryText': 'Vous avez déjà un compte ?',
    'agent.signup.secondaryLabel': 'Connexion',
    'agent.signup.backToSite': 'Retour au site principal',
    'agent.signup.toastCreated': 'Compte enregistré — en attente d\'approbation. Connexion impossible tant qu\'il n\'est pas approuvé.',
    'agent.signup.toastSaveRecoveryFirst': 'Compte enregistré — enregistrez votre phrase de récupération. La connexion reste bloquée jusqu\'à l\'approbation.',
    'agent.signup.pendingNotice': 'Votre compte agent est en attente d\'approbation. Vous ne pouvez pas vous connecter tant qu\'il n\'est pas activé. Contactez support@mineme.site.',
    'agent.signup.error.nameRequired': 'Le nom complet est obligatoire.',
    'agent.signup.error.usernameInvalid': 'Le nom d\'utilisateur ne peut contenir que des lettres, chiffres et tirets optionnels.',
    'agent.signup.error.usernameMin': 'Le nom d\'utilisateur doit comporter au moins {{min}} caractères.',
    'agent.signup.error.usernameMax': 'Le nom d\'utilisateur doit comporter au plus {{max}} caractères.',
    'agent.signup.error.usernameTaken': 'Ce nom d\'utilisateur est déjà pris.',
    'agent.signup.error.usernameCheckWait': 'Attendez la fin de la vérification du nom d\'utilisateur.',
    'agent.signup.error.emailRequired': 'L\'e-mail est obligatoire.',
    'agent.signup.error.passwordRequired': 'Le mot de passe est obligatoire.',
    'agent.signup.error.confirmRequired': 'La confirmation du mot de passe est obligatoire.',
    'agent.signup.error.passwordsMismatch': 'Les mots de passe ne correspondent pas.',
    'agent.signup.error.passwordMin': 'Le mot de passe doit contenir au moins 8 caractères.',
    'agent.signup.error.captchaWrong': 'Le captcha est obligatoire et doit être correct.',
    'agent.signup.error.referralRequired': 'Le code de parrainage agent est obligatoire.',
    'agent.signup.error.referralInvalid':
      'Le code ne peut contenir que des lettres, des chiffres et des tirets optionnels.',
    'agent.signup.error.registrationFailed': 'Échec de l\'inscription',
    'agent.signup.form.labelFullName': 'Nom complet',
    'agent.signup.form.placeholderFullName': 'Votre nom légal',
    'agent.signup.form.labelUsername': 'Nom d\'utilisateur',
    'agent.signup.form.placeholderUsername': 'Choisissez votre identifiant agent',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} caractères sans tirets ; lettres et chiffres (tirets autorisés à la saisie).',
    'agent.signup.form.labelReferral': 'Code de parrainage agent (obligatoire)',
    'agent.signup.form.placeholderReferral': "Nom d'utilisateur de l'agent parrain",
    'agent.signup.form.referralHint':
      'Seul un agent existant peut parrainer un nouvel agent. Les comptes utilisateur ne sont pas acceptés.',
    'agent.signup.form.labelEmail': 'E-mail',
    'agent.signup.form.placeholderEmail': 'Saisir l\'e-mail',
    'agent.signup.form.labelPassword': 'Mot de passe (obligatoire)',
    'agent.signup.form.placeholderPassword': 'Créer un mot de passe',
    'agent.signup.form.labelConfirmPassword': 'Confirmer le mot de passe (obligatoire)',
    'agent.signup.form.placeholderConfirmPassword': 'Confirmer le mot de passe',
    'agent.signup.form.captchaRobot': 'Je ne suis pas un robot (obligatoire)',
    'agent.signup.form.captchaQuestion': 'Captcha : combien font {{a}} + {{b}} ?',
    'agent.signup.form.placeholderCaptcha': 'Réponse au captcha',
    'agent.signup.form.submitting': 'Création…',
    'agent.signup.form.submit': 'Créer un compte',
    'agent.signup.username.available': 'Ce nom d\'utilisateur est disponible.',
    'agent.signup.username.taken': 'Ce nom d\'utilisateur est déjà pris.',
    'agent.signup.username.invalidChars': 'Utilisez uniquement des lettres, chiffres et tirets optionnels.',
    'agent.signup.username.invalidMin': 'Au moins {{min}} caractères (sans les tirets).',
    'agent.signup.username.invalidGeneric': 'Ce nom d\'utilisateur ne peut pas être utilisé.',
    'agent.signup.recovery.title': 'Enregistrez votre phrase de récupération',
    'agent.signup.recovery.body': 'C\'est la seule fois où nous pouvons l\'afficher. Notez-la et conservez-la hors ligne. Vous en aurez besoin pour réinitialiser votre mot de passe.',
    'agent.signup.recovery.warn': 'Ne partagez jamais cette phrase. Quiconque la possède peut réinitialiser votre mot de passe.',
    'agent.signup.recovery.copy': 'Copier la phrase',
    'agent.signup.recovery.copiedToast': 'Phrase copiée',
    'agent.signup.recovery.checkbox': 'J\'ai noté ou sauvegardé en lieu sûr ma phrase de récupération de 12 mots.',
    'agent.signup.recovery.continue': 'Continuer',
  },
  ar: {
    'agent.signup.title': 'تسجيل الوكيل',
    'agent.signup.subtitle': 'أنشئ حساب الوكيل. بعد التسجيل يجب أن يوافق المسؤول قبل تسجيل الدخول.',
    'agent.signup.secondaryText': 'لديك حساب بالفعل؟',
    'agent.signup.secondaryLabel': 'دخول',
    'agent.signup.backToSite': 'العودة إلى الموقع الرئيسي',
    'agent.signup.toastCreated': 'تم تسجيل الحساب — بانتظار موافقة المسؤول. لا يمكن تسجيل الدخول حتى تتم الموافقة.',
    'agent.signup.toastSaveRecoveryFirst': 'تم تسجيل الحساب — احفظ عبارة الاستعادة. يبقى تسجيل الدخول مقفلاً حتى الموافقة.',
    'agent.signup.pendingNotice': 'حساب الوكيل بانتظار موافقة المسؤول. لا يمكنك تسجيل الدخول حتى يتم التفعيل. تواصل مع support@mineme.site.',
    'agent.signup.error.nameRequired': 'الاسم الكامل مطلوب.',
    'agent.signup.error.usernameInvalid': 'اسم المستخدم يجب أن يحتوي فقط على أحرف وأرقام وشرطات اختيارية.',
    'agent.signup.error.usernameMin': 'اسم المستخدم يجب أن يكون {{min}} أحرف على الأقل.',
    'agent.signup.error.usernameMax': 'اسم المستخدم يجب ألا يتجاوز {{max}} حرفاً.',
    'agent.signup.error.usernameTaken': 'اسم المستخدم هذا مستخدم بالفعل.',
    'agent.signup.error.usernameCheckWait': 'انتظر حتى تنتهي عملية التحقق من اسم المستخدم.',
    'agent.signup.error.emailRequired': 'البريد الإلكتروني مطلوب.',
    'agent.signup.error.passwordRequired': 'كلمة المرور إلزامية.',
    'agent.signup.error.confirmRequired': 'تأكيد كلمة المرور إلزامي.',
    'agent.signup.error.passwordsMismatch': 'كلمتا المرور غير متطابقتين.',
    'agent.signup.error.passwordMin': 'كلمة المرور يجب أن تكون 8 أحرف على الأقل.',
    'agent.signup.error.captchaWrong': 'الكابتشا إلزامية ويجب أن تكون صحيحة.',
    'agent.signup.error.referralRequired': 'رمز إحالة الوكيل مطلوب.',
    'agent.signup.error.referralInvalid':
      'يجب أن يحتوي الرمز على أحرف وأرقام وشرطات اختيارية فقط.',
    'agent.signup.error.registrationFailed': 'فشل التسجيل',
    'agent.signup.form.labelFullName': 'الاسم الكامل',
    'agent.signup.form.placeholderFullName': 'اسمك القانوني',
    'agent.signup.form.labelUsername': 'اسم المستخدم',
    'agent.signup.form.placeholderUsername': 'اختر اسم مستخدم تسجيل الوكيل',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} حرفاً بعد إزالة الشرطات؛ أحرف وأرقام (يُسمح بالشرطات أثناء الكتابة).',
    'agent.signup.form.labelReferral': 'رمز إحالة الوكيل (إلزامي)',
    'agent.signup.form.placeholderReferral': 'اسم مستخدم الوكيل الراعي',
    'agent.signup.form.referralHint':
      'يمكن للوكيل الحالي فقط إحالة وكيل جديد. لا يمكن استخدام حسابات المستخدمين.',
    'agent.signup.form.labelEmail': 'البريد الإلكتروني',
    'agent.signup.form.placeholderEmail': 'أدخل البريد',
    'agent.signup.form.labelPassword': 'كلمة المرور (إلزامي)',
    'agent.signup.form.placeholderPassword': 'أنشئ كلمة مرور',
    'agent.signup.form.labelConfirmPassword': 'تأكيد كلمة المرور (إلزامي)',
    'agent.signup.form.placeholderConfirmPassword': 'أكد كلمة المرور',
    'agent.signup.form.captchaRobot': 'لست روبوتاً (إلزامي)',
    'agent.signup.form.captchaQuestion': 'الكابتشا: كم {{a}} + {{b}}؟',
    'agent.signup.form.placeholderCaptcha': 'أدخل إجابة الكابتشا',
    'agent.signup.form.submitting': 'جاري الإنشاء…',
    'agent.signup.form.submit': 'إنشاء حساب',
    'agent.signup.username.available': 'اسم المستخدم متاح.',
    'agent.signup.username.taken': 'اسم المستخدم مستخدم بالفعل.',
    'agent.signup.username.invalidChars': 'استخدم أحرفاً وأرقاماً وشرطات اختيارية فقط.',
    'agent.signup.username.invalidMin': 'يجب أن يكون اسم المستخدم {{min}} أحرف على الأقل (بعد إزالة الشرطات).',
    'agent.signup.username.invalidGeneric': 'لا يمكن استخدام اسم المستخدم هذا.',
    'agent.signup.recovery.title': 'احفظ عبارة الاسترداد',
    'agent.signup.recovery.body': 'نعرضها هذه المرة فقط. اكتبها واحفظها دون اتصال. ستحتاجها لإعادة تعيين كلمة المرور إذا نسيتها.',
    'agent.signup.recovery.warn': 'لا تشارك هذه العبارة أبداً. من يملكها يمكنه إعادة تعيين كلمة مرورك.',
    'agent.signup.recovery.copy': 'نسخ العبارة',
    'agent.signup.recovery.copiedToast': 'تم نسخ العبارة',
    'agent.signup.recovery.checkbox': 'لقد كتبتُ أو حفظتُ بأمان عبارة الاسترداد المكونة من 12 كلمة.',
    'agent.signup.recovery.continue': 'متابعة',
  },
  ja: {
    'agent.signup.title': 'エージェント登録',
    'agent.signup.subtitle': 'エージェントアカウントを作成します。登録後、管理者が承認するまでログインできません。',
    'agent.signup.secondaryText': 'すでにアカウントをお持ちですか？',
    'agent.signup.secondaryLabel': 'ログイン',
    'agent.signup.backToSite': 'メインサイトに戻る',
    'agent.signup.toastCreated': '登録完了 — 管理者の承認待ちです。承認されるまでログインできません。',
    'agent.signup.toastSaveRecoveryFirst': '登録完了 — リカバリーフレーズを保存してください。承認までログインできません。',
    'agent.signup.pendingNotice': 'エージェントアカウントは管理者承認待ちです。有効化されるまでログインできません。support@mineme.site までご連絡ください。',
    'agent.signup.error.nameRequired': '氏名は必須です。',
    'agent.signup.error.usernameInvalid': 'ユーザー名は英数字と任意のハイフンのみ使用できます。',
    'agent.signup.error.usernameMin': 'ユーザー名は{{min}}文字以上にしてください。',
    'agent.signup.error.usernameMax': 'ユーザー名は{{max}}文字以下にしてください。',
    'agent.signup.error.usernameTaken': 'このユーザー名は既に使用されています。',
    'agent.signup.error.usernameCheckWait': 'ユーザー名の確認が終わるまでお待ちください。',
    'agent.signup.error.emailRequired': 'メールアドレスは必須です。',
    'agent.signup.error.passwordRequired': 'パスワードは必須です。',
    'agent.signup.error.confirmRequired': 'パスワード確認は必須です。',
    'agent.signup.error.passwordsMismatch': 'パスワードが一致しません。',
    'agent.signup.error.passwordMin': 'パスワードは8文字以上にしてください。',
    'agent.signup.error.captchaWrong': 'CAPTCHAは必須で、正しく入力してください。',
    'agent.signup.error.referralRequired': 'エージェント紹介コードは必須です。',
    'agent.signup.error.referralInvalid': 'コードは英数字と任意のハイフンのみ使用できます。',
    'agent.signup.error.registrationFailed': '登録に失敗しました',
    'agent.signup.form.labelFullName': '氏名',
    'agent.signup.form.placeholderFullName': '氏名（本名）',
    'agent.signup.form.labelUsername': 'ユーザー名',
    'agent.signup.form.placeholderUsername': 'エージェントログイン名を選択',
    'agent.signup.form.usernameHint': 'ハイフン除く{{min}}–{{max}}文字；英数字（入力時のハイフンは可）。',
    'agent.signup.form.labelReferral': 'エージェント紹介コード（必須）',
    'agent.signup.form.placeholderReferral': 'スポンサーエージェントのユーザー名',
    'agent.signup.form.referralHint':
      '新しいエージェントを紹介できるのは既存のエージェントのみです。ユーザーアカウントは使用できません。',
    'agent.signup.form.labelEmail': 'メール',
    'agent.signup.form.placeholderEmail': 'メールを入力',
    'agent.signup.form.labelPassword': 'パスワード（必須）',
    'agent.signup.form.placeholderPassword': 'パスワードを作成',
    'agent.signup.form.labelConfirmPassword': 'パスワード確認（必須）',
    'agent.signup.form.placeholderConfirmPassword': 'パスワードを再入力',
    'agent.signup.form.captchaRobot': '私はロボットではありません（必須）',
    'agent.signup.form.captchaQuestion': 'CAPTCHA: {{a}} + {{b}} は？',
    'agent.signup.form.placeholderCaptcha': 'CAPTCHAの答え',
    'agent.signup.form.submitting': '作成中…',
    'agent.signup.form.submit': 'アカウントを作成',
    'agent.signup.username.available': 'このユーザー名は利用できます。',
    'agent.signup.username.taken': 'このユーザー名は既に使用されています。',
    'agent.signup.username.invalidChars': '英数字と任意のハイフンのみ使用してください。',
    'agent.signup.username.invalidMin': 'ハイフン除く{{min}}文字以上にしてください。',
    'agent.signup.username.invalidGeneric': 'このユーザー名は使用できません。',
    'agent.signup.recovery.title': 'リカバリーフレーズを保存',
    'agent.signup.recovery.body': '表示できるのは今回のみです。書き留めてオフラインで保管してください。パスワードを忘れたときの再設定に必要です。',
    'agent.signup.recovery.warn': 'このフレーズを共有しないでください。知っている人はパスワードを再設定できます。',
    'agent.signup.recovery.copy': 'フレーズをコピー',
    'agent.signup.recovery.copiedToast': 'コピーしました',
    'agent.signup.recovery.checkbox': '12語のリカバリーフレーズを書き留めたか安全に保存しました。',
    'agent.signup.recovery.continue': '続ける',
  },
  ko: {
    'agent.signup.title': '에이전트 가입',
    'agent.signup.subtitle': '에이전트 계정을 만드세요. 등록 후 관리자 승인 전까지 로그인할 수 없습니다.',
    'agent.signup.secondaryText': '이미 계정이 있나요?',
    'agent.signup.secondaryLabel': '로그인',
    'agent.signup.backToSite': '메인 사이트로 돌아가기',
    'agent.signup.toastCreated': '등록 완료 — 관리자 승인 대기 중. 승인 전까지 로그인할 수 없습니다.',
    'agent.signup.toastSaveRecoveryFirst': '등록 완료 — 복구 문구를 저장하세요. 승인 전까지 로그인이 잠깁니다.',
    'agent.signup.pendingNotice': '에이전트 계정이 관리자 승인 대기 중입니다. 활성화될 때까지 로그인할 수 없습니다. support@mineme.site 로 문의하세요.',
    'agent.signup.error.nameRequired': '전체 이름은 필수입니다.',
    'agent.signup.error.usernameInvalid': '사용자 이름은 영문, 숫자 및 선택적 하이픈만 사용할 수 있습니다.',
    'agent.signup.error.usernameMin': '사용자 이름은 최소 {{min}}자여야 합니다.',
    'agent.signup.error.usernameMax': '사용자 이름은 최대 {{max}}자까지입니다.',
    'agent.signup.error.usernameTaken': '이 사용자 이름은 이미 사용 중입니다.',
    'agent.signup.error.usernameCheckWait': '사용자 이름 확인이 끝날 때까지 기다려 주세요.',
    'agent.signup.error.emailRequired': '이메일은 필수입니다.',
    'agent.signup.error.passwordRequired': '비밀번호는 필수입니다.',
    'agent.signup.error.confirmRequired': '비밀번호 확인은 필수입니다.',
    'agent.signup.error.passwordsMismatch': '비밀번호가 일치하지 않습니다.',
    'agent.signup.error.passwordMin': '비밀번호는 최소 8자여야 합니다.',
    'agent.signup.error.captchaWrong': '캡차는 필수이며 정확해야 합니다.',
    'agent.signup.error.referralRequired': '에이전트 추천 코드는 필수입니다.',
    'agent.signup.error.referralInvalid':
      '코드는 영문, 숫자 및 선택적 하이픈만 사용할 수 있습니다.',
    'agent.signup.error.registrationFailed': '가입에 실패했습니다',
    'agent.signup.form.labelFullName': '전체 이름',
    'agent.signup.form.placeholderFullName': '법적 이름',
    'agent.signup.form.labelUsername': '사용자 이름',
    'agent.signup.form.placeholderUsername': '에이전트 로그인 사용자명 선택',
    'agent.signup.form.usernameHint': '하이픈 제외 {{min}}–{{max}}자; 영문·숫자 (입력 시 하이픈 허용).',
    'agent.signup.form.labelReferral': '에이전트 추천 코드(필수)',
    'agent.signup.form.placeholderReferral': '스폰서 에이전트 사용자 이름',
    'agent.signup.form.referralHint':
      '기존 에이전트만 새 에이전트를 추천할 수 있습니다. 사용자 계정은 사용할 수 없습니다.',
    'agent.signup.form.labelEmail': '이메일',
    'agent.signup.form.placeholderEmail': '이메일 입력',
    'agent.signup.form.labelPassword': '비밀번호(필수)',
    'agent.signup.form.placeholderPassword': '비밀번호 만들기',
    'agent.signup.form.labelConfirmPassword': '비밀번호 확인(필수)',
    'agent.signup.form.placeholderConfirmPassword': '비밀번호 확인',
    'agent.signup.form.captchaRobot': '로봇이 아닙니다(필수)',
    'agent.signup.form.captchaQuestion': '캡차: {{a}} + {{b}} = ?',
    'agent.signup.form.placeholderCaptcha': '캡차 답 입력',
    'agent.signup.form.submitting': '만드는 중…',
    'agent.signup.form.submit': '계정 만들기',
    'agent.signup.username.available': '사용 가능한 사용자 이름입니다.',
    'agent.signup.username.taken': '이미 사용 중인 사용자 이름입니다.',
    'agent.signup.username.invalidChars': '영문, 숫자 및 선택적 하이픈만 사용하세요.',
    'agent.signup.username.invalidMin': '하이픈 제외 최소 {{min}}자여야 합니다.',
    'agent.signup.username.invalidGeneric': '이 사용자 이름은 사용할 수 없습니다.',
    'agent.signup.recovery.title': '복구 구문 저장',
    'agent.signup.recovery.body': '이번에만 보여 드릴 수 있습니다. 적어 두고 오프라인에 보관하세요. 비밀번호를 잊었을 때 재설정에 필요합니다.',
    'agent.signup.recovery.warn': '이 구문을 공유하지 마세요. 아는 사람은 비밀번호를 재설정할 수 있습니다.',
    'agent.signup.recovery.copy': '구문 복사',
    'agent.signup.recovery.copiedToast': '구문이 복사되었습니다',
    'agent.signup.recovery.checkbox': '12단어 복구 구문을 적었거나 안전하게 저장했습니다.',
    'agent.signup.recovery.continue': '계속',
  },
  'zh-CN': {
    'agent.signup.title': '代理注册',
    'agent.signup.subtitle': '创建代理账户。注册后需管理员批准才能登录。',
    'agent.signup.secondaryText': '已有账户？',
    'agent.signup.secondaryLabel': '登录',
    'agent.signup.backToSite': '返回主站',
    'agent.signup.toastCreated': '已注册 — 等待管理员批准。批准前无法登录。',
    'agent.signup.toastSaveRecoveryFirst': '已注册 — 请保存恢复短语。批准前无法登录。',
    'agent.signup.pendingNotice': '您的代理账户正在等待管理员批准。激活前无法登录。如需帮助请联系 support@mineme.site。',
    'agent.signup.error.nameRequired': '姓名为必填项。',
    'agent.signup.error.usernameInvalid': '用户名只能包含字母、数字和可选连字符。',
    'agent.signup.error.usernameMin': '用户名至少需要 {{min}} 个字符。',
    'agent.signup.error.usernameMax': '用户名最多 {{max}} 个字符。',
    'agent.signup.error.usernameTaken': '该用户名已被占用。',
    'agent.signup.error.usernameCheckWait': '请等待用户名检查完成。',
    'agent.signup.error.emailRequired': '邮箱为必填项。',
    'agent.signup.error.passwordRequired': '密码为必填项。',
    'agent.signup.error.confirmRequired': '确认密码为必填项。',
    'agent.signup.error.passwordsMismatch': '两次密码不一致。',
    'agent.signup.error.passwordMin': '密码至少需要 8 个字符。',
    'agent.signup.error.captchaWrong': '验证码为必填且必须正确。',
    'agent.signup.error.referralRequired': '代理推荐码为必填项。',
    'agent.signup.error.referralInvalid': '推荐码只能包含字母、数字和可选连字符。',
    'agent.signup.error.registrationFailed': '注册失败',
    'agent.signup.form.labelFullName': '全名',
    'agent.signup.form.placeholderFullName': '您的法定姓名',
    'agent.signup.form.labelUsername': '用户名',
    'agent.signup.form.placeholderUsername': '选择代理登录用户名',
    'agent.signup.form.usernameHint': '去除连字符后 {{min}}–{{max}} 个字符；字母和数字（输入时可含连字符）。',
    'agent.signup.form.labelReferral': '代理推荐码（必填）',
    'agent.signup.form.placeholderReferral': '赞助代理用户名',
    'agent.signup.form.referralHint': '只有现有代理可以推荐新代理，不能使用用户账户。',
    'agent.signup.form.labelEmail': '邮箱',
    'agent.signup.form.placeholderEmail': '输入邮箱',
    'agent.signup.form.labelPassword': '密码（必填）',
    'agent.signup.form.placeholderPassword': '创建密码',
    'agent.signup.form.labelConfirmPassword': '确认密码（必填）',
    'agent.signup.form.placeholderConfirmPassword': '确认密码',
    'agent.signup.form.captchaRobot': '我不是机器人（必填）',
    'agent.signup.form.captchaQuestion': '验证码：{{a}} + {{b}} = ？',
    'agent.signup.form.placeholderCaptcha': '输入验证码答案',
    'agent.signup.form.submitting': '创建中…',
    'agent.signup.form.submit': '创建账户',
    'agent.signup.username.available': '该用户名可用。',
    'agent.signup.username.taken': '该用户名已被占用。',
    'agent.signup.username.invalidChars': '仅使用字母、数字和可选连字符。',
    'agent.signup.username.invalidMin': '去除连字符后至少 {{min}} 个字符。',
    'agent.signup.username.invalidGeneric': '无法使用该用户名。',
    'agent.signup.recovery.title': '保存恢复短语',
    'agent.signup.recovery.body': '我们只能在此时显示一次。请写下并离线保存。忘记密码时需要用它重置。',
    'agent.signup.recovery.warn': '切勿分享此短语。拥有它的人可以重置您的密码。',
    'agent.signup.recovery.copy': '复制短语',
    'agent.signup.recovery.copiedToast': '已复制短语',
    'agent.signup.recovery.checkbox': '我已写下或安全保存了 12 词恢复短语。',
    'agent.signup.recovery.continue': '继续',
  },
  pt: {
    'agent.signup.title': 'Cadastro de agente',
    'agent.signup.subtitle': 'Crie sua conta de agente. Após o cadastro, um administrador deve aprovar antes que você possa entrar.',
    'agent.signup.secondaryText': 'Já tem uma conta?',
    'agent.signup.secondaryLabel': 'Entrar',
    'agent.signup.backToSite': 'Voltar ao site principal',
    'agent.signup.toastCreated': 'Conta registrada — aguardando aprovação. Você não pode entrar até ser aprovado.',
    'agent.signup.toastSaveRecoveryFirst': 'Conta registrada — salve sua frase de recuperação. O login fica bloqueado até a aprovação.',
    'agent.signup.pendingNotice': 'Sua conta de agente está pendente de aprovação. Você não pode entrar até ser ativada. Contate support@mineme.site.',
    'agent.signup.error.nameRequired': 'O nome completo é obrigatório.',
    'agent.signup.error.usernameInvalid': 'O usuário só pode conter letras, números e hífens opcionais.',
    'agent.signup.error.usernameMin': 'O nome de usuário deve ter pelo menos {{min}} caracteres.',
    'agent.signup.error.usernameMax': 'O nome de usuário deve ter no máximo {{max}} caracteres.',
    'agent.signup.error.usernameTaken': 'Este nome de usuário já está em uso.',
    'agent.signup.error.usernameCheckWait': 'Aguarde a verificação do nome de usuário terminar.',
    'agent.signup.error.emailRequired': 'O e-mail é obrigatório.',
    'agent.signup.error.passwordRequired': 'A senha é obrigatória.',
    'agent.signup.error.confirmRequired': 'A confirmação da senha é obrigatória.',
    'agent.signup.error.passwordsMismatch': 'As senhas não coincidem.',
    'agent.signup.error.passwordMin': 'A senha deve ter pelo menos 8 caracteres.',
    'agent.signup.error.captchaWrong': 'O captcha é obrigatório e deve estar correto.',
    'agent.signup.error.referralRequired': 'O código de indicação do agente é obrigatório.',
    'agent.signup.error.referralInvalid':
      'O código só pode conter letras, números e hífens opcionais.',
    'agent.signup.error.registrationFailed': 'Falha no cadastro',
    'agent.signup.form.labelFullName': 'Nome completo',
    'agent.signup.form.placeholderFullName': 'Seu nome legal',
    'agent.signup.form.labelUsername': 'Nome de usuário',
    'agent.signup.form.placeholderUsername': 'Escolha o usuário de login do agente',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} caracteres sem hífens; letras e números (hífens permitidos ao digitar).',
    'agent.signup.form.labelReferral': 'Código de indicação do agente (obrigatório)',
    'agent.signup.form.placeholderReferral': 'Usuário do agente patrocinador',
    'agent.signup.form.referralHint':
      'Somente um agente existente pode indicar um novo agente. Contas de usuário não são aceitas.',
    'agent.signup.form.labelEmail': 'E-mail',
    'agent.signup.form.placeholderEmail': 'Digite o e-mail',
    'agent.signup.form.labelPassword': 'Senha (obrigatória)',
    'agent.signup.form.placeholderPassword': 'Criar senha',
    'agent.signup.form.labelConfirmPassword': 'Confirmar senha (obrigatória)',
    'agent.signup.form.placeholderConfirmPassword': 'Confirmar senha',
    'agent.signup.form.captchaRobot': 'Não sou um robô (obrigatório)',
    'agent.signup.form.captchaQuestion': 'Captcha: quanto é {{a}} + {{b}}?',
    'agent.signup.form.placeholderCaptcha': 'Resposta do captcha',
    'agent.signup.form.submitting': 'Criando…',
    'agent.signup.form.submit': 'Criar conta',
    'agent.signup.username.available': 'Este nome de usuário está disponível.',
    'agent.signup.username.taken': 'Este nome de usuário já está em uso.',
    'agent.signup.username.invalidChars': 'Use apenas letras, números e hífens opcionais.',
    'agent.signup.username.invalidMin': 'Pelo menos {{min}} caracteres (sem hífens).',
    'agent.signup.username.invalidGeneric': 'Este nome de usuário não pode ser usado.',
    'agent.signup.recovery.title': 'Guarde sua frase de recuperação',
    'agent.signup.recovery.body': 'Só podemos mostrá-la desta vez. Anote e guarde offline. Você precisará dela para redefinir a senha se esquecer.',
    'agent.signup.recovery.warn': 'Nunca compartilhe esta frase. Quem a tiver pode redefinir sua senha.',
    'agent.signup.recovery.copy': 'Copiar frase',
    'agent.signup.recovery.copiedToast': 'Frase copiada',
    'agent.signup.recovery.checkbox': 'Anotei ou salvei com segurança minha frase de recuperação de 12 palavras.',
    'agent.signup.recovery.continue': 'Continuar',
  },
  it: {
    'agent.signup.title': 'Registrazione agente',
    'agent.signup.subtitle': 'Crea il tuo account agente. Dopo la registrazione un admin deve approvarlo prima che tu possa accedere.',
    'agent.signup.secondaryText': 'Hai già un account?',
    'agent.signup.secondaryLabel': 'Accedi',
    'agent.signup.backToSite': 'Torna al sito principale',
    'agent.signup.toastCreated': 'Account registrato — in attesa di approvazione. Non puoi accedere finché non è approvato.',
    'agent.signup.toastSaveRecoveryFirst': 'Account registrato — salva la frase di recupero. L\'accesso resta bloccato fino all\'approvazione.',
    'agent.signup.pendingNotice': 'Il tuo account agente è in attesa di approvazione. Non puoi accedere finché non è attivato. Contatta support@mineme.site.',
    'agent.signup.error.nameRequired': 'Il nome completo è obbligatorio.',
    'agent.signup.error.usernameInvalid': 'Lo username può contenere solo lettere, numeri e trattini opzionali.',
    'agent.signup.error.usernameMin': 'Il nome utente deve avere almeno {{min}} caratteri.',
    'agent.signup.error.usernameMax': 'Il nome utente deve avere al massimo {{max}} caratteri.',
    'agent.signup.error.usernameTaken': 'Questo nome utente è già in uso.',
    'agent.signup.error.usernameCheckWait': 'Attendi il completamento del controllo del nome utente.',
    'agent.signup.error.emailRequired': 'L\'email è obbligatoria.',
    'agent.signup.error.passwordRequired': 'La password è obbligatoria.',
    'agent.signup.error.confirmRequired': 'La conferma della password è obbligatoria.',
    'agent.signup.error.passwordsMismatch': 'Le password non coincidono.',
    'agent.signup.error.passwordMin': 'La password deve avere almeno 8 caratteri.',
    'agent.signup.error.captchaWrong': 'Il captcha è obbligatorio e deve essere corretto.',
    'agent.signup.error.referralRequired': 'Il codice referral agente è obbligatorio.',
    'agent.signup.error.referralInvalid':
      'Il codice può contenere solo lettere, numeri e trattini opzionali.',
    'agent.signup.error.registrationFailed': 'Registrazione non riuscita',
    'agent.signup.form.labelFullName': 'Nome completo',
    'agent.signup.form.placeholderFullName': 'Il tuo nome legale',
    'agent.signup.form.labelUsername': 'Nome utente',
    'agent.signup.form.placeholderUsername': 'Scegli username di accesso agente',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} caratteri senza trattini; lettere e numeri (trattini consentiti in digitazione).',
    'agent.signup.form.labelReferral': 'Codice referral agente (obbligatorio)',
    'agent.signup.form.placeholderReferral': 'Username agente sponsor',
    'agent.signup.form.referralHint':
      'Solo un agente esistente può invitare un nuovo agente. Gli account utente non sono ammessi.',
    'agent.signup.form.labelEmail': 'Email',
    'agent.signup.form.placeholderEmail': 'Inserisci email',
    'agent.signup.form.labelPassword': 'Password (obbligatoria)',
    'agent.signup.form.placeholderPassword': 'Crea password',
    'agent.signup.form.labelConfirmPassword': 'Conferma password (obbligatoria)',
    'agent.signup.form.placeholderConfirmPassword': 'Conferma password',
    'agent.signup.form.captchaRobot': 'Non sono un robot (obbligatorio)',
    'agent.signup.form.captchaQuestion': 'Captcha: quanto fa {{a}} + {{b}}?',
    'agent.signup.form.placeholderCaptcha': 'Risposta captcha',
    'agent.signup.form.submitting': 'Creazione…',
    'agent.signup.form.submit': 'Crea account',
    'agent.signup.username.available': 'Questo nome utente è disponibile.',
    'agent.signup.username.taken': 'Questo nome utente è già in uso.',
    'agent.signup.username.invalidChars': 'Usa solo lettere, numeri e trattini opzionali.',
    'agent.signup.username.invalidMin': 'Almeno {{min}} caratteri (senza trattini).',
    'agent.signup.username.invalidGeneric': 'Questo nome utente non può essere usato.',
    'agent.signup.recovery.title': 'Salva la frase di recupero',
    'agent.signup.recovery.body': 'Possiamo mostrarla solo questa volta. Annotala e conservala offline. Ti servirà per reimpostare la password se la dimentichi.',
    'agent.signup.recovery.warn': 'Non condividere mai questa frase. Chi la possiede può reimpostare la password.',
    'agent.signup.recovery.copy': 'Copia frase',
    'agent.signup.recovery.copiedToast': 'Frase copiata',
    'agent.signup.recovery.checkbox': 'Ho annotato o salvato in modo sicuro la mia frase di recupero da 12 parole.',
    'agent.signup.recovery.continue': 'Continua',
  },
  ru: {
    'agent.signup.title': 'Регистрация агента',
    'agent.signup.subtitle': 'Создайте аккаунт агента. После регистрации администратор должен одобрить его, прежде чем вы сможете войти.',
    'agent.signup.secondaryText': 'Уже есть аккаунт?',
    'agent.signup.secondaryLabel': 'Войти',
    'agent.signup.backToSite': 'На главный сайт',
    'agent.signup.toastCreated': 'Аккаунт зарегистрирован — ожидает одобрения. Вход недоступен до одобрения.',
    'agent.signup.toastSaveRecoveryFirst': 'Аккаунт зарегистрирован — сохраните фразу восстановления. Вход заблокирован до одобрения.',
    'agent.signup.pendingNotice': 'Ваш аккаунт агента ожидает одобрения администратора. Вход недоступен до активации. Пишите на support@mineme.site.',
    'agent.signup.error.nameRequired': 'Укажите полное имя.',
    'agent.signup.error.usernameInvalid': 'Имя пользователя может содержать только буквы, цифры и необязательные дефисы.',
    'agent.signup.error.usernameMin': 'Имя пользователя — не менее {{min}} символов.',
    'agent.signup.error.usernameMax': 'Имя пользователя — не более {{max}} символов.',
    'agent.signup.error.usernameTaken': 'Это имя пользователя уже занято.',
    'agent.signup.error.usernameCheckWait': 'Дождитесь проверки имени пользователя.',
    'agent.signup.error.emailRequired': 'Укажите email.',
    'agent.signup.error.passwordRequired': 'Пароль обязателен.',
    'agent.signup.error.confirmRequired': 'Подтверждение пароля обязательно.',
    'agent.signup.error.passwordsMismatch': 'Пароли не совпадают.',
    'agent.signup.error.passwordMin': 'Пароль должен быть не короче 8 символов.',
    'agent.signup.error.captchaWrong': 'Капча обязательна и должна быть верной.',
    'agent.signup.error.referralRequired': 'Код приглашения агента обязателен.',
    'agent.signup.error.referralInvalid':
      'Код может содержать только буквы, цифры и необязательные дефисы.',
    'agent.signup.error.registrationFailed': 'Регистрация не удалась',
    'agent.signup.form.labelFullName': 'Полное имя',
    'agent.signup.form.placeholderFullName': 'Ваше юридическое имя',
    'agent.signup.form.labelUsername': 'Имя пользователя',
    'agent.signup.form.placeholderUsername': 'Выберите логин агента',
    'agent.signup.form.usernameHint': '{{min}}–{{max}} символов без дефисов; буквы и цифры (дефисы при вводе допустимы).',
    'agent.signup.form.labelReferral': 'Код приглашения агента (обязательно)',
    'agent.signup.form.placeholderReferral': 'Имя агента-спонсора',
    'agent.signup.form.referralHint':
      'Только существующий агент может пригласить нового агента. Учётные записи пользователей недопустимы.',
    'agent.signup.form.labelEmail': 'Email',
    'agent.signup.form.placeholderEmail': 'Введите email',
    'agent.signup.form.labelPassword': 'Пароль (обязательно)',
    'agent.signup.form.placeholderPassword': 'Придумайте пароль',
    'agent.signup.form.labelConfirmPassword': 'Подтверждение пароля (обязательно)',
    'agent.signup.form.placeholderConfirmPassword': 'Подтвердите пароль',
    'agent.signup.form.captchaRobot': 'Я не робот (обязательно)',
    'agent.signup.form.captchaQuestion': 'Капча: сколько {{a}} + {{b}}?',
    'agent.signup.form.placeholderCaptcha': 'Ответ на капчу',
    'agent.signup.form.submitting': 'Создание…',
    'agent.signup.form.submit': 'Создать аккаунт',
    'agent.signup.username.available': 'Имя пользователя свободно.',
    'agent.signup.username.taken': 'Имя пользователя уже занято.',
    'agent.signup.username.invalidChars': 'Используйте только буквы, цифры и необязательные дефисы.',
    'agent.signup.username.invalidMin': 'Не менее {{min}} символов (без дефисов).',
    'agent.signup.username.invalidGeneric': 'Это имя пользователя нельзя использовать.',
    'agent.signup.recovery.title': 'Сохраните фразу восстановления',
    'agent.signup.recovery.body': 'Мы показываем её только сейчас. Запишите и храните офлайн. Она нужна для сброса пароля.',
    'agent.signup.recovery.warn': 'Никому не сообщайте эту фразу. У кого она есть — может сбросить пароль.',
    'agent.signup.recovery.copy': 'Скопировать фразу',
    'agent.signup.recovery.copiedToast': 'Фраза скопирована',
    'agent.signup.recovery.checkbox': 'Я записал или надёжно сохранил 12-словную фразу восстановления.',
    'agent.signup.recovery.continue': 'Продолжить',
  },
  bn: {
    'agent.signup.title': 'এজেন্ট নিবন্ধন',
    'agent.signup.subtitle': 'আপনার এজেন্ট অ্যাকাউন্ট তৈরি করুন। নিবন্ধনের পর অ্যাডমিন অনুমোদন না হওয়া পর্যন্ত লগইন করা যাবে না।',
    'agent.signup.secondaryText': 'ইতিমধ্যে অ্যাকাউন্ট আছে?',
    'agent.signup.secondaryLabel': 'সাইন ইন',
    'agent.signup.backToSite': 'মূল সাইটে ফিরে যান',
    'agent.signup.toastCreated': 'অ্যাকাউন্ট নিবন্ধিত — অনুমোদনের অপেক্ষায়। অনুমোদনের আগে সাইন ইন করা যাবে না।',
    'agent.signup.toastSaveRecoveryFirst': 'অ্যাকাউন্ট নিবন্ধিত — রিকভারি ফ্রেজ সংরক্ষণ করুন। অনুমোদনের আগে লগইন বন্ধ থাকবে।',
    'agent.signup.pendingNotice': 'আপনার এজেন্ট অ্যাকাউন্ট অ্যাডমিন অনুমোদনের অপেক্ষায়। সক্রিয় না হওয়া পর্যন্ত লগইন করা যাবে না। সাহায্যের জন্য support@mineme.site।',
    'agent.signup.error.nameRequired': 'পূর্ণ নাম প্রয়োজন।',
    'agent.signup.error.usernameInvalid': 'ব্যবহারকারীনামে শুধু অক্ষর, সংখ্যা ও ঐচ্ছিক হাইফেন থাকতে পারে।',
    'agent.signup.error.usernameMin': 'ব্যবহারকারীর নাম কমপক্ষে {{min}} অক্ষরের হতে হবে।',
    'agent.signup.error.usernameMax': 'ব্যবহারকারীর নাম সর্বোচ্চ {{max}} অক্ষরের হতে হবে।',
    'agent.signup.error.usernameTaken': 'এই ব্যবহারকারীর নামটি ইতিমধ্যে নেওয়া।',
    'agent.signup.error.usernameCheckWait': 'ব্যবহারকারীর নাম পরীক্ষা শেষ হওয়া পর্যন্ত অপেক্ষা করুন।',
    'agent.signup.error.emailRequired': 'ইমেইল প্রয়োজন।',
    'agent.signup.error.passwordRequired': 'পাসওয়ার্ড বাধ্যতামূলক।',
    'agent.signup.error.confirmRequired': 'পাসওয়ার্ড নিশ্চিতকরণ বাধ্যতামূলক।',
    'agent.signup.error.passwordsMismatch': 'পাসওয়ার্ড মিলছে না।',
    'agent.signup.error.passwordMin': 'পাসওয়ার্ড কমপক্ষে ৮ অক্ষরের হতে হবে।',
    'agent.signup.error.captchaWrong': 'ক্যাপচা বাধ্যতামূলক এবং সঠিক হতে হবে।',
    'agent.signup.error.referralRequired': 'এজেন্ট রেফারেল কোড বাধ্যতামূলক।',
    'agent.signup.error.referralInvalid':
      'কোডে শুধু অক্ষর, সংখ্যা এবং ঐচ্ছিক হাইফেন থাকতে পারে।',
    'agent.signup.error.registrationFailed': 'নিবন্ধন ব্যর্থ হয়েছে',
    'agent.signup.form.labelFullName': 'পূর্ণ নাম',
    'agent.signup.form.placeholderFullName': 'আপনার আইনি নাম',
    'agent.signup.form.labelUsername': 'ব্যবহারকারীর নাম',
    'agent.signup.form.placeholderUsername': 'এজেন্ট লগইন ব্যবহারকারীনাম বেছে নিন',
    'agent.signup.form.usernameHint': 'হাইফেন বাদে {{min}}–{{max}} অক্ষর; অক্ষর ও সংখ্যা (টাইপ করার সময় হাইফেন অনুমোদিত)।',
    'agent.signup.form.labelReferral': 'এজেন্ট রেফারেল কোড (বাধ্যতামূলক)',
    'agent.signup.form.placeholderReferral': 'স্পনসর এজেন্টের ব্যবহারকারীর নাম',
    'agent.signup.form.referralHint':
      'শুধু বিদ্যমান এজেন্ট নতুন এজেন্ট রেফার করতে পারে। ব্যবহারকারী অ্যাকাউন্ট গ্রহণযোগ্য নয়।',
    'agent.signup.form.labelEmail': 'ইমেইল',
    'agent.signup.form.placeholderEmail': 'ইমেইল লিখুন',
    'agent.signup.form.labelPassword': 'পাসওয়ার্ড (বাধ্যতামূলক)',
    'agent.signup.form.placeholderPassword': 'পাসওয়ার্ড তৈরি করুন',
    'agent.signup.form.labelConfirmPassword': 'পাসওয়ার্ড নিশ্চিত করুন (বাধ্যতামূলক)',
    'agent.signup.form.placeholderConfirmPassword': 'পাসওয়ার্ড নিশ্চিত করুন',
    'agent.signup.form.captchaRobot': 'আমি রোবট নই (বাধ্যতামূলক)',
    'agent.signup.form.captchaQuestion': 'ক্যাপচা: {{a}} + {{b}} কত?',
    'agent.signup.form.placeholderCaptcha': 'ক্যাপচার উত্তর লিখুন',
    'agent.signup.form.submitting': 'তৈরি হচ্ছে…',
    'agent.signup.form.submit': 'অ্যাকাউন্ট তৈরি করুন',
    'agent.signup.username.available': 'এই ব্যবহারকারীর নামটি উপলব্ধ।',
    'agent.signup.username.taken': 'এই ব্যবহারকারীর নামটি ইতিমধ্যে নেওয়া।',
    'agent.signup.username.invalidChars': 'শুধু অক্ষর, সংখ্যা ও ঐচ্ছিক হাইফেন ব্যবহার করুন।',
    'agent.signup.username.invalidMin': 'হাইফেন বাদে কমপক্ষে {{min}} অক্ষর।',
    'agent.signup.username.invalidGeneric': 'এই ব্যবহারকারীর নাম ব্যবহার করা যাবে না।',
    'agent.signup.recovery.title': 'আপনার পুনরুদ্ধার বাক্যাংশ সংরক্ষণ করুন',
    'agent.signup.recovery.body': 'আমরা এটি শুধু এইবার দেখাতে পারি। লিখে অফলাইনে রাখুন। পাসওয়ার্ড ভুলে গেলে এটি লাগবে।',
    'agent.signup.recovery.warn': 'এই বাক্যাংশ কখনও শেয়ার করবেন না। যার কাছে আছে সে পাসওয়ার্ড রিসেট করতে পারে।',
    'agent.signup.recovery.copy': 'বাক্যাংশ কপি করুন',
    'agent.signup.recovery.copiedToast': 'বাক্যাংশ কপি হয়েছে',
    'agent.signup.recovery.checkbox': 'আমি আমার ১২-শব্দের পুনরুদ্ধার বাক্যাংশ লিখেছি বা নিরাপদে সংরক্ষণ করেছি।',
    'agent.signup.recovery.continue': 'চালিয়ে যান',
  },
  hi: {
    'agent.signup.title': 'एजेंट पंजीकरण',
    'agent.signup.subtitle': 'अपना एजेंट खाता बनाएं। पंजीकरण के बाद एडमिन स्वीकृति तक साइन इन नहीं कर सकते।',
    'agent.signup.secondaryText': 'पहले से खाता है?',
    'agent.signup.secondaryLabel': 'साइन इन',
    'agent.signup.backToSite': 'मुख्य साइट पर वापस',
    'agent.signup.toastCreated': 'खाता पंजीकृत — एडमिन स्वीकृति लंबित। स्वीकृति तक साइन इन नहीं कर सकते।',
    'agent.signup.toastSaveRecoveryFirst': 'खाता पंजीकृत — रिकवरी वाक्यांश सहेजें। स्वीकृति तक लॉगिन लॉक रहेगा।',
    'agent.signup.pendingNotice': 'आपका एजेंट खाता एडमिन स्वीकृति की प्रतीक्षा में है। सक्रिय होने तक लॉग इन नहीं कर सकते। सहायता: support@mineme.site।',
    'agent.signup.error.nameRequired': 'पूरा नाम आवश्यक है।',
    'agent.signup.error.usernameInvalid': 'उपयोगकर्ता नाम में केवल अक्षर, संख्याएँ और वैकल्पिक हाइफ़न हो सकते हैं।',
    'agent.signup.error.usernameMin': 'उपयोगकर्ता नाम कम से कम {{min}} अक्षर का हो।',
    'agent.signup.error.usernameMax': 'उपयोगकर्ता नाम अधिकतम {{max}} अक्षर का हो।',
    'agent.signup.error.usernameTaken': 'यह उपयोगकर्ता नाम पहले से लिया गया है।',
    'agent.signup.error.usernameCheckWait': 'उपयोगकर्ता नाम जांच पूरी होने तक प्रतीक्षा करें।',
    'agent.signup.error.emailRequired': 'ईमेल आवश्यक है।',
    'agent.signup.error.passwordRequired': 'पासवर्ड अनिवार्य है।',
    'agent.signup.error.confirmRequired': 'पासवर्ड पुष्टि अनिवार्य है।',
    'agent.signup.error.passwordsMismatch': 'पासवर्ड मेल नहीं खाते।',
    'agent.signup.error.passwordMin': 'पासवर्ड कम से कम 8 अक्षर का हो।',
    'agent.signup.error.captchaWrong': 'कैप्चा अनिवार्य है और सही होना चाहिए।',
    'agent.signup.error.referralRequired': 'एजेंट रेफ़रल कोड अनिवार्य है।',
    'agent.signup.error.referralInvalid':
      'कोड में केवल अक्षर, संख्याएँ और वैकल्पिक हाइफ़न हो सकते हैं।',
    'agent.signup.error.registrationFailed': 'पंजीकरण विफल',
    'agent.signup.form.labelFullName': 'पूरा नाम',
    'agent.signup.form.placeholderFullName': 'आपका कानूनी नाम',
    'agent.signup.form.labelUsername': 'उपयोगकर्ता नाम',
    'agent.signup.form.placeholderUsername': 'एजेंट लॉगिन उपयोगकर्ता नाम चुनें',
    'agent.signup.form.usernameHint': 'हाइफ़न हटाने के बाद {{min}}–{{max}} अक्षर; अक्षर और संख्याएँ (टाइप करते समय हाइफ़न अनुमत)।',
    'agent.signup.form.labelReferral': 'एजेंट रेफ़रल कोड (अनिवार्य)',
    'agent.signup.form.placeholderReferral': 'प्रायोजक एजेंट उपयोगकर्ता नाम',
    'agent.signup.form.referralHint':
      'केवल मौजूदा एजेंट नए एजेंट को रेफर कर सकता है। उपयोगकर्ता खाते स्वीकार नहीं हैं।',
    'agent.signup.form.labelEmail': 'ईमेल',
    'agent.signup.form.placeholderEmail': 'ईमेल दर्ज करें',
    'agent.signup.form.labelPassword': 'पासवर्ड (अनिवार्य)',
    'agent.signup.form.placeholderPassword': 'पासवर्ड बनाएं',
    'agent.signup.form.labelConfirmPassword': 'पासवर्ड की पुष्टि (अनिवार्य)',
    'agent.signup.form.placeholderConfirmPassword': 'पासवर्ड की पुष्टि करें',
    'agent.signup.form.captchaRobot': 'मैं रोबोट नहीं हूँ (अनिवार्य)',
    'agent.signup.form.captchaQuestion': 'कैप्चा: {{a}} + {{b}} कितना है?',
    'agent.signup.form.placeholderCaptcha': 'कैप्चा उत्तर दर्ज करें',
    'agent.signup.form.submitting': 'बन रहा है…',
    'agent.signup.form.submit': 'खाता बनाएं',
    'agent.signup.username.available': 'यह उपयोगकर्ता नाम उपलब्ध है।',
    'agent.signup.username.taken': 'यह उपयोगकर्ता नाम पहले से लिया गया है।',
    'agent.signup.username.invalidChars': 'केवल अक्षर, संख्याएँ और वैकल्पिक हाइफ़न उपयोग करें।',
    'agent.signup.username.invalidMin': 'हाइफ़न हटाने के बाद कम से कम {{min}} अक्षर।',
    'agent.signup.username.invalidGeneric': 'यह उपयोगकर्ता नाम उपयोग नहीं किया जा सकता।',
    'agent.signup.recovery.title': 'अपना रिकवरी वाक्यांश सहेजें',
    'agent.signup.recovery.body': 'हम इसे केवल इस बार दिखा सकते हैं। लिखकर ऑफ़लाइन रखें। पासवर्ड भूलने पर रीसेट के लिए चाहिए।',
    'agent.signup.recovery.warn': 'इस वाक्यांश को कभी साझा न करें। जिसके पास है वह पासवर्ड रीसेट कर सकता है।',
    'agent.signup.recovery.copy': 'वाक्यांश कॉपी करें',
    'agent.signup.recovery.copiedToast': 'वाक्यांश कॉपी हो गया',
    'agent.signup.recovery.checkbox': 'मैंने अपना 12-शब्द रिकवरी वाक्यांश लिख लिया है या सुरक्षित रूप से सहेजा है।',
    'agent.signup.recovery.continue': 'जारी रखें',
  },
};
